import SignatureHelper from "@utils/helpers/signature-helper";
import SignatoryCard from "@components/core/subComponents/SignatoryCard/SignatoryCard";
import React, { Dispatch, SetStateAction } from "react";
import { Member } from "@type/core/offices/offices.types";
import { Signatory, Signature } from "@type/core/dashboard/dashboard.types";
import { TransactionType } from "@type/core/transaction/transaction.types";
import useSignatoryCardDimension from "@utils/hooks/useSignatoryCardDimension";

interface SignatoriesProps {
  src: string | undefined;
  index: number;
  signatories: Signatory[];
  signatures: Signature[];
  transactionType: TransactionType;
  members: Member[];
  setManualPositioning: Dispatch<SetStateAction<boolean>>;
  filename: string;
  officeId: string;
  pageNumber: number;
  numberOfFiles: number;
  buttonLoading?: boolean;
}

const Signatories: React.FC<SignatoriesProps> = ({
  src,
  index,
  signatories,
  transactionType,
  signatures,
  members,
  officeId,
  setManualPositioning,
  pageNumber,
}: SignatoriesProps) => {
  const { width, height } = useSignatoryCardDimension({
    rank: index,
    pageNumber,
  });
  return signatories.map((signatory, indexSignatory) => {
    if (src) {
      const signatorySignatures = signatures.filter(
        (s) => s.email === signatory.email && s.rank === index,
      );
      signatorySignatures.map((signature) => {
        const signatorySignaturePicture = signatory.signaturePicture?.find(
          (signaturePicture) => signaturePicture.isDefault,
        );
        const signaturePictureRank =
          signature?.signaturePictureRank && signature.signaturePictureRank > 0
            ? signature.signaturePictureRank
            : signatorySignaturePicture?.rank;
        if (signature && signaturePictureRank) {
          signature.signaturePictureRank = signaturePictureRank;
        } else if (signature) {
          signature.signaturePictureRank = 1;
        }
      });

      const isUserInOffice = !!members.find(
        (member) =>
          member.officeId === officeId && member.email === signatory.email,
      );
      const shouldSignatureBeDisabled =
        SignatureHelper.shouldSignatureBeDisabled(
          signatures,
          signatory,
          signatories,
          index,
        );
      return (
        <div
          key={`${index}_${indexSignatory}`}
          className="align-items-md-baseline"
        >
          {signatorySignatures.map((signature, indexSignature) => {
            return (
              <div
                className="position-relative"
                key={SignatureHelper.buildSignatureIdentificator(
                  index - 1,
                  indexSignatory,
                  indexSignature,
                )}
              >
                <SignatoryCard
                  cardDimensionHeight={height}
                  cardDimensionWidth={width}
                  documentRank={index}
                  transactionType={transactionType}
                  email={signatory.email}
                  firstname={signatory.firstname}
                  lastname={signatory.lastname}
                  signatorySignaturePictures={signatory.signaturePicture}
                  signatures={signatorySignatures}
                  setManualPositioning={setManualPositioning}
                  isUserInOffice={isUserInOffice}
                  pageNumber={pageNumber}
                  signaturePictureRank={signature?.signaturePictureRank}
                  signaturePriorityRule={signature?.signaturePriorityRule}
                  officeId={officeId}
                  signatureIdentificator={SignatureHelper.buildSignatureIdentificator(
                    index - 1,
                    indexSignatory,
                    indexSignature,
                  )}
                  isDisabled={shouldSignatureBeDisabled && !signature.isMoved}
                  isSignatoryCounterDisabled={SignatureHelper.shouldSignaturesBeDisabled(
                    signatures,
                    index,
                  )}
                  signatureCount={SignatureHelper.getSignatureAmountForOneSignatoryOfOneFile(
                    signatures,
                    signatory,
                    index,
                  )}
                />
              </div>
            );
          })}
        </div>
      );
    } else {
      return null;
    }
  });
};

export default Signatories;
